import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { SubHeadding, SubPanel } from '@/components/SubPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat, optionalBooleanFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const Vision: FC<ViewProps> = ({ result, editLink }) => {
  const leftItem = result.regularHealthCheckupResultItems.find(item => item.itemCode === 'vision_left');
  const rightItem = result.regularHealthCheckupResultItems.find(item => item.itemCode === 'vision_right');
  return (
    <Panel>
      <Link to={`${editLink}#vision`}>
        <Headding icon={<Edit icon={16} />}>視力</Headding>
      </Link>
      <Item>
        <Grid colGap>
          <SubPanel>
            <Link to={`${editLink}#vision_left`}>
              <SubHeadding icon={<Edit icon={16} />}>左眼</SubHeadding>
            </Link>
            <Grid sub>
              <Dl>
                <Dt>実施有無</Dt>
                <Dd>{optionalBooleanFormat(leftItem?.checked ?? false, '有', '無')}</Dd>
              </Dl>
              <Dl>
                <Dt>結果</Dt>
                <Dd>{displayFormat(leftItem?.value)}</Dd>
              </Dl>
            </Grid>
          </SubPanel>
          <SubPanel>
            <Link to={`${editLink}#vision_right`}>
              <SubHeadding icon={<Edit icon={16} />}>右眼</SubHeadding>
            </Link>
            <Grid sub>
              <Dl>
                <Dt>実施有無</Dt>
                <Dd>{optionalBooleanFormat(rightItem?.checked ?? false, '有', '無')}</Dd>
              </Dl>
              <Dl>
                <Dt>結果</Dt>
                <Dd>{displayFormat(rightItem?.value)}</Dd>
              </Dl>
            </Grid>
          </SubPanel>
        </Grid>
      </Item>
    </Panel>
  );
};
